import { render } from "./Information.vue?vue&type=template&id=5cdc6b15&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"

import "./Information.vue?vue&type=style&index=0&id=5cdc6b15&scoped=true&lang=less"

import exportComponent from "/home/benjamin/projects/web-case/maxstock-firebase/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdc6b15"]])

export default __exports__